import './App.css';
import Header from './components/Header/Header';
import Restaurent from './components/Restaurent/Restaurent';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Restaurent></Restaurent>
    </div>
  );
}

export default App;
